import {
  aMatchList,
  aMatchListItem,
  aMatchListItemPage,
  anItemMeta,
  mockMatchListItemEditorOperationQuery,
} from '__generated__';

export const getMatchListItemEditorQueryHandler = ({
  name,
  description,
  timeToLive,
  itemValue,
  itemDescription,
  itemExpiration,
}) => {
  return mockMatchListItemEditorOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        matchList: aMatchList({
          defaultTtl: timeToLive,
          description: description,
          id: '1',
          items: aMatchListItemPage({
            hasNextPage: false,
            objects: [],
            total: 0,
          }),
          name,
          targetColumn: '1',
        }),
        matchListItem: aMatchListItem({
          id: '1',
          value: itemValue,
          expiration: itemExpiration,
          meta: anItemMeta({ description: itemDescription }),
        }),
      })
    );
  });
};

export const handlers = [
  mockMatchListItemEditorOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        matchList: aMatchList(),
        matchListItem: aMatchListItem(),
      })
    );
  }),
];
